import React, { type ReactElement } from 'react';

import style from './style.module.scss';

interface IProps {
  children: ReactElement | string | number;
  label: string;
  dataQa?: string;
  leftElement?: ReactElement;
  rightElement?: ReactElement;
}

const TextFieldComponent: React.FC<IProps> = ({ children, label = '', dataQa = '' }) => (
  <div className={style.fieldBlock}>
    {label && <div className={style.fieldLabel}>{label}</div>}
    <div className={style.textField} data-qa={dataQa}>
      {children}
    </div>
  </div>
);

export default TextFieldComponent;
